import { useAuth } from '@/contexts/AuthContext'

export const useDisplayName = () => {
  const { user } = useAuth()

  const getDisplayName = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName} ${user.lastName}`
    }
    return user?.email || user?.username
  }

  return { getDisplayName, displayName: getDisplayName() }
}
